import React from 'react';
import { useTranslation } from 'react-i18next';
import listIllustration from '@/assets/images/list-view.webp';
import { Button } from '@/components/Button';
import { Icon } from '@/components/Icons';
import { Modal } from '@/components/Modal';
import {
  ButtonVariant,
  IconType,
  ModalSize,
  ModalVariant,
  Size,
} from '@/types/components';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const AddStudentErrorModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      label={t('offers.add.notFoundTitle')}
      variant={ModalVariant.BottomSheet}
      size={ModalSize.Small}
      onClose={onClose}
    >
      <button
        type="button"
        onClick={onClose}
        aria-label={t('global.close')}
        className="absolute top-5 right-5 flex size-4 shrink-0 cursor-pointer items-center justify-center text-foreground"
      >
        <Icon icon={IconType.Close} />
      </button>
      <div className="flex flex-1 flex-col items-center justify-center gap-4 px-5 pt-6 pb-4 md:pt-5">
        <img
          src={listIllustration}
          alt=""
          className="size-30 shrink-0"
          width={120}
          height={120}
        />
        <div className="flex flex-col items-center gap-1 text-center">
          <h2 className="text-headline-20 text-foreground">
            {t('offers.add.notFoundTitle')}
          </h2>
          <p className="text-body-14 whitespace-pre-line text-muted-foreground">
            {t('offers.add.notFoundDescription')}
          </p>
        </div>
      </div>

      <div className="flex shrink-0 gap-3 bg-background px-4 pt-4 pb-[calc(24px+env(safe-area-inset-bottom))] md:p-5">
        <Button
          variant={ButtonVariant.Primary}
          size={Size.Large}
          onClick={onClose}
          className="flex-1"
        >
          {t('offers.add.closeToList')}
        </Button>
      </div>
    </Modal>
  );
};
